import axios from '../config/axios';
import {actions as A} from '../constants/actions';
import {setRequestId} from '../utils/setRequestId';
import {checkNextStepForDuplicateFirstNameValue, isSecondStepNext} from '../utils/stepSubmit';

export const getNextStep = (regType = 'all', preventRedirect = false) => {
  return (dispatch) => {
    dispatch({
      type: A.GET_NEXT_STEP
    });
    setRequestId();

    return axios.get('/regGeneral/getNextStep', {
      params: {regType, preventRedirect}
    })
      .then((response) => {
        const {data} = response.data;
        const {
          nextStep,
          currentUserStepNumber,
          totalSteps,
          goBack,
          desktopCompletedStages,
          firstName,
          ...payload
        } = data;
        const formValues = checkNextStepForDuplicateFirstNameValue(nextStep, regType)
          ? {...payload, firstName}
          : payload;

        dispatch({
          type: A.GET_NEXT_STEP_SUCCESS,
          payload: {
            nextStep,
            currentUserStepNumber,
            totalSteps,
            goBack,
            desktopCompletedStages
          }
        });
        dispatch({
          type: A.SET_STEP_PAYLOAD,
          payload: formValues
        });
        dispatch({
          type: A.SET_USER_NAME,
          payload: isSecondStepNext(nextStep, regType) ? '' : firstName
        });
      })
      .catch((err) => {
        dispatch({
          type: A.GET_NEXT_STEP_FAILURE,
          payload: {errorMessage: err.message}
        })
      });
  };
};
